export * from './highlight-response.mocks';
export * from './highlight-type';
export * from './highlight-update.request';
export * from './highlight.factory';
export * from './highlight.response';
//# sourceMappingURL=index.js.map